import React from 'react'


export const VirtualTours=()=>{

    return (<p>VirtualTours</p>)
}

